import React from "react";
import { useContact } from '../utils/ContactContext';

export default function About(props) {
    const { setOpen } = useContact();
  return (
    <>
      <div>
        {" "}
        <div id="smooth-wrapper">
          <div id="smooth-content">
            <div class="breadcrumb-section mb-120">
              <div class="container mb-70">
                <div class="row">
                  <div class="col-xl-8 col-lg-10">
                    <div class="breadcrumb-content">
                      <ul class="breadcrumb-list">
                        <li>
                          <a href="about-company.html#">Home</a>
                        </li>
                        <li>
                          <svg
                            width="24"
                            height="6"
                            viewBox="0 0 24 6"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M-3.26633e-05 2.88672L2.88672 5.77347L5.77347 2.88672L2.88672 -3.26633e-05L-3.26633e-05 2.88672ZM23.7735 2.88672L20.8867 -3.26633e-05L18 2.88672L20.8867 5.77347L23.7735 2.88672ZM2.88672 2.88672V3.38672H20.8867V2.88672V2.38672H2.88672V2.88672Z" />
                          </svg>
                          About Inisght Wide
                        </li>
                      </ul>
                      <h1>
                        Empowering Australian Businesses Through Intelligent
                        Software Solutions
                      </h1>
                      <div class="para">
                        <div class="icon">
                          <svg
                            width="6"
                            height="49"
                            viewBox="0 0 6 49"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M2.88672 -3.26633e-05L-3.26633e-05 2.88672L2.88672 5.77347L5.77347 2.88672L2.88672 -3.26633e-05ZM2.88672 48.7735L5.77347 45.8867L2.88672 43L-3.26633e-05 45.8867L2.88672 48.7735ZM2.88672 2.88672H2.38672L2.38672 45.8867H2.88672H3.38672L3.38672 2.88672H2.88672Z" />
                          </svg>
                        </div>
                        <p>
                          {" "}
                          At Insight Wide, we bridge the gap between complex
                          business challenges and intuitive digital solutions.
                          Based in Melbourne, we specialize in high-performance
                          CRM systems and bespoke software development
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="about-us-section home2-about-us mb-120">
              <div class="container">
                <div class="about-us-content-wrap">
                  <div class="row mb-80 gy-5">
                    <div class="col-lg-4">
                      <div class="left-about-area">
                        <div class="section-title">
                          <span>About Softro</span>
                        </div>
                        <div class="about-image">
                          <img
                            src="assets/image/start-up2/about-us-award.gif"
                            alt=""
                          />
                          <div class="award-img">
                            <img
                              src="assets/image/start-up2/award-img.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-8">
                      <div class="right-about-area">
                        <div class="section-title">
                          <h2 class="text-anim">
                            Insight Wide is an Australian developer of ERP
                            business management software and has a global
                            network of partners.
                          </h2>
                        </div>
                        <div
                          class="counter-area-wrap fade_anim"
                          data-delay=".2"
                          data-fade-from="left"
                        >
                          <div class="author-area">
                            <ul class="author-img-grp">
                              <li>
                                <img
                                  src="assets/image/start-up/counter-people-img1.png"
                                  alt=""
                                />
                              </li>
                              <li>
                                <img
                                  src="assets/image/start-up/counter-people-img2.png"
                                  alt=""
                                />
                              </li>
                              <li>
                                <img
                                  src="assets/image/start-up/counter-people-img3.png"
                                  alt=""
                                />
                              </li>
                            </ul>
                            <h3>
                              we've already{" "}
                              <strong>
                                <span class="counter_number">20</span>k+
                              </strong>
                              active users
                            </h3>
                          </div>
                        </div>
                        <div
                          class="video-and-content-area fade_anim"
                          data-delay=".2"
                          data-fade-from="right"
                        >
                          <div class="content">
                            <p>
                              When you partner with us, you don’t just gain an
                              integrated ERP solution but also a team that is
                              invested in your success. With deep industry
                              experience, we have the ability to understand your
                              specific needs and build innovative solutions
                              enabling decision making that drives efficiencies,
                              increasing revenue and ultimately profitable
                              growth.
                            </p>
                            <a class="primary-btn1" href="#"  onClick={(e) => { e.preventDefault(); setOpen(true); }}> 
                              <span>
                                Get a Free Consultation
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g>
                                    <path d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                                  </g>
                                </svg>
                              </span>
                              <span>
                                Get a Free Consultation
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g>
                                    <path d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                                  </g>
                                </svg>
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="counter-wrap">
                    <div class="row gy-sm-5 gy-4 gx-xl-4 gx-2">
                      <div class="col-md-3 col-6 d-flex justify-content-sm-center divider">
                        <div class="single-countdown">
                          <div class="number">
                            <h2 class="counter">12</h2>
                          </div>
                          <span>years of experience</span>
                        </div>
                      </div>
                      <div class="col-md-3 col-6 d-flex justify-content-center divider">
                        <div class="single-countdown">
                          <div class="number">
                            <h2 class="counter">05</h2>
                          </div>
                          <span>Industry Awards</span>
                        </div>
                      </div>
                      <div class="col-md-3 col-6 d-flex justify-content-lg-center  justify-content-center divider">
                        <div class="single-countdown">
                          <div class="number">
                            <h2 class="counter">2</h2>
                            <span>K</span>
                          </div>
                          <span>Global Clients Served</span>
                        </div>
                      </div>
                      <div class="col-md-3  col-6 d-flex justify-content-sm-center justify-content-end">
                        <div class="single-countdown">
                          <div class="number">
                            <h2 class="counter">3</h2>
                            <span>K</span>
                          </div>
                          <span>Users Engaged</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

                <div class="team-details-page mb-120">
                <div class="container">
                    <div class="row gy-5">
                        <div class="col-lg-6">
                            <div class="profile-area">
                                <div class="profile-img">
                                    <img src="assets/owner.png" alt=""/>
                                </div>
                                <div class="profile-content">
                                    <div class="para">
                                        <div class="icon">
                                            <svg width="6" height="79" viewBox="0 0 6 79"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M2.88672 -3.26633e-05L-3.26633e-05 2.88672L2.88672 5.77347L5.77347 2.88672L2.88672 -3.26633e-05ZM2.88672 78.7735L5.77347 75.8867L2.88672 73L-3.58543e-05 75.8867L2.88672 78.7735ZM2.88672 2.88672L2.38672 2.88672L2.38672 75.8867L2.88672 75.8867L3.38672 75.8867L3.38672 2.88672L2.88672 2.88672Z" />
                                            </svg>
                                        </div>
                                        <p> “Growth happens when you stop fighting with spreadsheets and start focusing on your vision.”</p>
                                    </div>
                                    <div class="signature-icon">
                                        <img class="dark-logo" src="assets/image/innerpage/vector/signature.svg" alt=""/>
                                        <img class="white-logo" src="assets/image/innerpage/vector/signature-white.svg" alt=""/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 d-flex justify-content-lg-center">
                            <div class="team-details-content">
                                <div class="name-social-area">
                                    <span>The Powerhouse Behind InsightWide</span>
                                    <h2>Developed by Teknoverse</h2>
                                    
                                </div>
                                <div class="content">
                                    <p>InsightWide is a flagship product of Teknoverse, a premier software design and development agency. Born out of a mission to bridge the gap between complex technology and business efficiency, Teknoverse engineered this platform specifically for the Australian market.</p>
                                    <p>
                                      Our team recognized that local enterprises were losing precious time and growth opportunities due to overwhelming manual workloads and fragmented processes. InsightWide was built to consolidate those workflows into one seamless, intelligent ecosystem.
                                    </p>
                                </div>
                               
                                 <a className="primary-btn1" href="https://teknoverse.com.au/" target="_blank">
                        <span>
                           Visit Teknoverse
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                            </g>
                          </svg>
                        </span>
                        <span>
                        Visit Teknoverse
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94971C6.37964 5.45636 8.04642 6.14449 8.42737 6.15336L12.6752 6.15336L4.95937 13.8691C4.68614 14.1424 4.68613 14.5854 4.95937 14.8586C5.23261 15.1319 5.67561 15.1319 5.94884 14.8586L13.6646 7.14283L13.6646 11.3906C13.6647 11.777 14.4631 13.4349 14.8494 13.435C15.2358 13.4349 15.0638 11.777 15.0638 11.3906L15.0638 5.45375C15.0637 5.06741 14.7506 4.75424 14.3642 4.75416L8.42738 4.75416C8.0235 4.75908 6.35447 4.48628 6.36416 4.94971Z" />
                            </g>
                          </svg>
                        </span>
                      </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="our-service-section mb-120">
              <div class="container">
                <div class="row">
                  <div class="col-lg-12 mb-70">
                    <div class="section-title three white-color">
                      <span>About</span>
                      <h2 class="text-anim">
                        Why Choose Insight Wide for Your Business?
                      </h2>
                      <div class="right-content">
                        
                        <a href="service.html" class="view-more-btn">
                          View More
                          <svg
                            class="arrow"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94965C6.37964 5.4563 8.04642 6.14443 8.42737 6.1533L12.6752 6.1533L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8586C5.23261 15.1318 5.67561 15.1318 5.94884 14.8586L13.6646 7.14277L13.6646 11.3906C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45369C15.0637 5.06735 14.7506 4.75418 14.3642 4.7541L8.42738 4.7541C8.0235 4.75902 6.35447 4.48622 6.36416 4.94965Z" />
                            </g>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row gx-xxl-4 gx-lg-3 g-4 gy-sm-5 gy-4">
                  <div
                    class="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".2"
                  >
                    <div class="service-card">
                      <div class="icon">
                        <svg
                          width="50"
                          height="50"
                          viewBox="0 0 50 50"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M48.1158 26.5422L44.2675 17.1029C44.1223 16.8125 43.9044 16.6672 43.614 16.6672H40.0561V15.215C40.0561 14.852 39.8383 14.5615 39.4752 14.4889L37.0065 14.0533C36.716 13.0367 36.353 12.0928 35.8447 11.2215L37.2969 9.11579C37.5147 8.82535 37.4421 8.4623 37.2243 8.17186L34.0295 4.9044C33.8116 4.68657 33.376 4.61396 33.0855 4.83179L30.9798 6.28399C30.1085 5.77572 29.1646 5.41267 28.148 5.12223L27.7124 2.58088C27.6398 2.21783 27.3493 2 26.9863 2H22.4118C22.0488 2 21.7584 2.21783 21.6857 2.58088L21.2501 5.12223C20.2335 5.34006 19.2896 5.70311 18.3457 6.21138L16.24 4.75918C15.9496 4.54135 15.5865 4.61396 15.2961 4.83179L12.0286 8.02664C11.8108 8.24447 11.7382 8.68013 11.956 8.97057L13.4082 11.0763C12.8999 11.9476 12.4643 12.8915 12.1738 13.908L9.63248 14.3437C9.26943 14.4163 9.0516 14.7068 9.0516 15.0698V16.7398H5.56631C5.27587 16.7398 4.98543 16.8851 4.91282 17.1755L1.06449 26.5422C0.84666 27.0505 1.20971 27.5587 1.71798 27.5587H5.34848V43.7508C5.34848 46.2195 7.38157 48.18 9.7777 48.18H39.4026C41.8713 48.18 43.8318 46.1469 43.8318 43.7508V27.5587H47.4623C47.9706 27.5587 48.3336 27.0505 48.1158 26.5422ZM17.91 16.4494C18.4183 13.1819 21.1775 10.7132 24.5902 10.7132C28.0028 10.7132 30.762 13.1819 31.2703 16.4494H17.91ZM10.5764 15.6507L12.9725 15.215C13.263 15.1424 13.4808 14.9246 13.5534 14.7068C13.8439 13.545 14.2795 12.4558 14.933 11.4393C15.0782 11.2215 15.0782 10.8584 14.933 10.6406L13.5534 8.68013L15.9496 6.28399L17.91 7.66359C18.1279 7.8088 18.4183 7.8088 18.7087 7.66359C19.7253 7.01009 20.887 6.57443 21.9762 6.3566C22.2666 6.28399 22.4845 6.06616 22.5571 5.77572L22.9927 3.37959H26.3328L26.7685 5.84833C26.8411 6.13877 27.0589 6.3566 27.3493 6.42921C28.5111 6.71965 29.6002 7.15531 30.6168 7.8088C30.8346 7.95403 31.1977 7.95403 31.4155 7.8088L33.376 6.42921L35.7721 8.82535L34.3925 10.7858C34.2473 11.0036 34.2473 11.3667 34.3925 11.5845C35.046 12.6011 35.4817 13.7628 35.6995 14.852C35.7721 15.1424 35.9899 15.3603 36.2804 15.4329L38.6765 15.8685V16.4494H32.7951C32.2868 12.3832 28.8741 9.26101 24.6628 9.26101C20.4514 9.26101 17.0387 12.3832 16.5304 16.4494H10.649L10.5764 15.6507ZM42.3796 43.7508C42.3796 45.4208 41 46.7278 39.4026 46.7278H9.7777C8.10767 46.7278 6.80068 45.3482 6.80068 43.7508V27.5587H42.4522V43.7508H42.3796ZM2.80713 26.1065L6.07458 18.1194H43.1783L46.4458 26.1065H2.80713Z" />
                          <path d="M21.105 39.0312L19.6528 43.6056C19.5802 43.896 19.6528 44.2591 19.9432 44.4043C20.2337 44.6221 20.5241 44.6221 20.8146 44.4043L24.6629 41.5725L28.5112 44.4043C28.7291 44.6221 29.0921 44.6221 29.3826 44.4043C29.673 44.1865 29.7456 43.896 29.673 43.6056L28.2208 39.0312L32.0691 36.1994C32.3596 35.9815 32.4322 35.6911 32.3596 35.4007C32.287 35.1102 31.9965 34.8924 31.6335 34.8924H26.7686L25.3164 30.318C25.2438 30.0275 24.9533 29.8097 24.5903 29.8097C24.2998 29.8097 24.0094 30.0275 23.8642 30.318L22.412 34.8924H17.6197C17.3293 34.8924 17.0388 35.1102 16.8936 35.4007C16.821 35.6911 16.8936 36.0542 17.1841 36.1994L21.105 39.0312ZM22.9203 36.3446C23.2107 36.3446 23.5011 36.1268 23.6464 35.8363L24.5903 32.9319L25.5342 35.8363C25.6068 36.1268 25.8973 36.3446 26.2603 36.3446H29.3099L26.8412 38.1599C26.5508 38.3777 26.4781 38.6681 26.5508 38.9586L27.4947 41.863L25.0259 40.0477C24.8807 39.9751 24.7355 39.9025 24.5903 39.9025C24.4451 39.9025 24.2998 39.9751 24.1546 40.0477L21.6859 41.863L22.6298 38.9586C22.7024 38.6681 22.6298 38.3051 22.3394 38.1599L19.8706 36.3446H22.9203Z" />
                        </svg>
                      </div>
                      <div class="service-card-content">
                        <h3>
                          <a href="#">Collaborative Implementation</a>
                        </h3>
                        <p>
                          We work directly with customers during implementation
                        </p>
                        <a href="#" class="view-details-btn"  onClick={(e) => { e.preventDefault(); setOpen(true); }}>
                          Get A Quote
                          <svg
                            class="arrow"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z" />
                            </g>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".3"
                  >
                    <div class="service-card">
                      <div class="icon">
                        <svg
                          width="50"
                          height="50"
                          viewBox="0 0 50 50"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M46.4844 1.5625H3.51562C2.79067 1.5633 2.09564 1.85164 1.58301 2.36426C1.07039 2.87689 0.782051 3.57192 0.78125 4.29688V36.3281C0.782051 37.0531 1.07039 37.7481 1.58301 38.2607C2.09564 38.7734 2.79067 39.0617 3.51562 39.0625H32.1172L40.582 47.5273C41.0228 47.961 41.617 48.2029 42.2353 48.2004C42.8536 48.1978 43.4458 47.9511 43.883 47.5139C44.3202 47.0767 44.567 46.4845 44.5695 45.8662C44.572 45.2479 44.3301 44.6536 43.8965 44.2129L42.792 43.1074L38.7461 39.0625H46.4844C47.2093 39.0617 47.9044 38.7734 48.417 38.2607C48.9296 37.7481 49.2179 37.0531 49.2188 36.3281V4.29688C49.2179 3.57192 48.9296 2.87689 48.417 2.36426C47.9044 1.85164 47.2093 1.5633 46.4844 1.5625ZM26.2188 26.5352C26.1098 26.4258 25.9708 26.3513 25.8193 26.3213L23.0576 25.7686C22.9315 25.7434 22.801 25.7497 22.6779 25.787C22.5548 25.8244 22.4428 25.8915 22.3519 25.9825C22.261 26.0736 22.194 26.1856 22.1568 26.3088C22.1196 26.4319 22.1133 26.5623 22.1387 26.6885L22.6904 29.4502C22.7207 29.6015 22.7951 29.7405 22.9043 29.8496L27.4297 34.375H7.03125V6.25H42.9688V34.375H34.0586L26.2188 26.5352ZM26.7715 29.2969L25.667 30.4023L24.1768 28.9121L23.9004 27.5313L25.2812 27.8076L26.7715 29.2969ZM26.7715 31.5068L27.876 30.4023L31.7432 34.2695L30.6387 35.374L26.7715 31.5068ZM42.792 45.3174C42.9386 45.464 43.0209 45.6628 43.0209 45.8701C43.0209 46.0774 42.9386 46.2763 42.792 46.4229C42.6454 46.5694 42.4466 46.6518 42.2393 46.6518C42.0319 46.6518 41.8331 46.5694 41.6865 46.4229L41.1348 45.8701L42.2393 44.7656L42.792 45.3174ZM41.1348 43.6602L40.0293 44.7656L31.7432 36.4785L32.8477 35.374L41.1348 43.6602ZM47.6562 36.3281C47.656 36.6388 47.5324 36.9368 47.3127 37.1565C47.093 37.3762 46.7951 37.4997 46.4844 37.5H37.1836L35.6211 35.9375H43.75C43.9572 35.9375 44.1559 35.8552 44.3024 35.7087C44.4489 35.5622 44.5312 35.3634 44.5312 35.1562V5.46875C44.5312 5.26155 44.4489 5.06284 44.3024 4.91632C44.1559 4.76981 43.9572 4.6875 43.75 4.6875H6.25C6.0428 4.6875 5.84409 4.76981 5.69757 4.91632C5.55106 5.06284 5.46875 5.26155 5.46875 5.46875V35.1562C5.46875 35.3634 5.55106 35.5622 5.69757 35.7087C5.84409 35.8552 6.0428 35.9375 6.25 35.9375H28.9922L30.5547 37.5H3.51562C3.2049 37.4997 2.90698 37.3762 2.68727 37.1565C2.46756 36.9368 2.34401 36.6388 2.34375 36.3281V4.29688C2.34401 3.98615 2.46756 3.68823 2.68727 3.46852C2.90698 3.24881 3.2049 3.12526 3.51562 3.125H46.4844C46.7951 3.12526 47.093 3.24881 47.3127 3.46852C47.5324 3.68823 47.656 3.98615 47.6562 4.29688V36.3281Z" />
                          <path d="M3.90625 17.9687C3.69905 17.9687 3.50034 18.051 3.35382 18.1976C3.20731 18.3441 3.125 18.5428 3.125 18.75V23.4375C3.125 23.6447 3.20731 23.8434 3.35382 23.9899C3.50034 24.1364 3.69905 24.2187 3.90625 24.2187C4.11345 24.2187 4.31216 24.1364 4.45868 23.9899C4.60519 23.8434 4.6875 23.6447 4.6875 23.4375V18.75C4.6875 18.5428 4.60519 18.3441 4.45868 18.1976C4.31216 18.051 4.11345 17.9687 3.90625 17.9687ZM46.0938 18.75C45.8866 18.75 45.6878 18.8323 45.5413 18.9788C45.3948 19.1253 45.3125 19.324 45.3125 19.5312V21.0937C45.3125 21.3009 45.3948 21.4996 45.5413 21.6462C45.6878 21.7927 45.8866 21.875 46.0938 21.875C46.3009 21.875 46.4997 21.7927 46.6462 21.6462C46.7927 21.4996 46.875 21.3009 46.875 21.0937V19.5312C46.875 19.324 46.7927 19.1253 46.6462 18.9788C46.4997 18.8323 46.3009 18.75 46.0938 18.75ZM33.2102 12.6367C33.1137 12.6716 33.025 12.7252 32.9492 12.7944C32.8734 12.8636 32.812 12.947 32.7685 13.0399C32.725 13.1329 32.7002 13.2335 32.6955 13.336C32.6909 13.4385 32.7065 13.5409 32.7414 13.6374C33.1781 14.8742 33.1069 16.2336 32.5434 17.4179C32.3825 17.7491 32.2229 17.9612 32.0551 18.0665C31.7059 18.2861 31.1583 18.1422 30.7953 17.9521C30.4617 17.7628 30.1445 17.5458 29.8472 17.3034C29.6139 17.1247 29.3727 16.9398 29.1109 16.7687C28.2605 16.223 27.2954 15.881 26.2911 15.7693C25.2868 15.6576 24.2702 15.7793 23.3206 16.1249C21.7507 16.7116 20.6448 17.8796 20.361 19.2494C20.1805 20.1224 20.3469 20.9643 20.4937 21.7071L20.8608 23.5632C20.901 23.7665 21.0203 23.9455 21.1924 24.0609C21.3646 24.1763 21.5755 24.2185 21.7788 24.1784C21.9821 24.1383 22.1612 24.019 22.2765 23.8468C22.3919 23.6747 22.4342 23.4637 22.394 23.2604L22.0271 21.4044C21.9031 20.7777 21.775 20.1298 21.8915 19.5662C22.0966 18.5763 23.0468 17.8963 23.868 17.5888C24.5877 17.327 25.3581 17.2348 26.1192 17.3195C26.8804 17.4042 27.6117 17.6635 28.2562 18.0771C28.4691 18.2162 28.677 18.3756 28.8973 18.5443C29.2648 18.8418 29.6575 19.1067 30.071 19.3359C31.0615 19.8548 32.1142 19.8745 32.8868 19.3889C33.4493 19.0354 33.7624 18.4841 33.9488 18.0999C34.3222 17.3264 34.5377 16.4863 34.5827 15.6286C34.6276 14.7709 34.5011 13.9128 34.2106 13.1046C34.14 12.9099 33.9949 12.7513 33.8073 12.6635C33.6196 12.5758 33.4049 12.5661 33.2102 12.6367Z" />
                        </svg>
                      </div>
                      <div class="service-card-content">
                        <h3>
                          <a href="#"  onClick={(e) => { e.preventDefault(); setOpen(true); }}>All-in-One ERP </a>
                        </h3>
                        <p>
                          ERP software with accounting, operational and mobile
                          features
                        </p>
                        <a href="#" class="view-details-btn"  onClick={(e) => { e.preventDefault(); setOpen(true); }}>
                          Get A Quote
                          <svg
                            class="arrow"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z" />
                            </g>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".4"
                  >
                    <div class="service-card">
                      <div class="icon">
                        <svg
                          width="50"
                          height="50"
                          viewBox="0 0 50 50"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M44.686 3H5.194C4.61232 3.00065 4.05464 3.23202 3.64333 3.64333C3.23202 4.05464 3.00065 4.61232 3 5.194V36.6413C3.00065 37.223 3.23202 37.7807 3.64333 38.192C4.05464 38.6033 4.61232 38.8347 5.194 38.8353H19.5945L17.7994 45.4173H16.164V46.88H33.716V45.4173H32.0806L30.2855 38.8353H44.686C45.2677 38.8347 45.8254 38.6033 46.2367 38.192C46.648 37.7807 46.8793 37.223 46.88 36.6413V5.194C46.8793 4.61232 46.648 4.05464 46.2367 3.64333C45.8254 3.23202 45.2677 3.00065 44.686 3ZM30.5645 45.4173H19.3155L21.1106 38.8353H28.7694L30.5645 45.4173ZM45.4173 36.6413C45.4171 36.8352 45.34 37.0211 45.2029 37.1582C45.0658 37.2953 44.8799 37.3724 44.686 37.3727H5.194C5.00011 37.3724 4.81424 37.2953 4.67714 37.1582C4.54004 37.0211 4.46291 36.8352 4.46267 36.6413V33.716H45.4173V36.6413ZM17.678 26.7981L18.7535 25.7226L20.9541 26.598L23.2446 25.649L24.1794 23.4773H25.7006L26.6354 25.649L28.9259 26.5979L31.1265 25.7226L32.202 26.7981L31.3266 28.9987L32.2757 31.2893L34.4473 32.2242V32.2533H30.7433C30.5655 30.8396 29.8778 29.5394 28.8093 28.5968C27.7407 27.6542 26.3649 27.1341 24.94 27.1341C23.5151 27.1341 22.1393 27.6542 21.0707 28.5968C20.0022 29.5394 19.3145 30.8396 19.1367 32.2533H15.4327V32.2241L17.6043 31.2893L18.5534 28.9987L17.678 26.7981ZM29.2659 32.2533H20.6141C20.7866 31.2308 21.3158 30.3025 22.1077 29.633C22.8996 28.9635 23.903 28.5962 24.94 28.5962C25.977 28.5962 26.9804 28.9635 27.7723 29.633C28.5642 30.3025 29.0934 31.2308 29.2659 32.2533ZM45.4173 32.2533H35.91V31.2615L33.3996 30.1806L32.9052 28.9875L33.9169 26.4444L31.4801 24.0078L28.9371 25.0194L27.7441 24.5251L26.6632 22.0147H23.2168L22.1361 24.525L20.943 25.0195L18.4 24.0078L15.9632 26.4444L16.9749 28.9875L16.4805 30.1806L13.97 31.2615V32.2533H4.46267V5.194C4.46291 5.00011 4.54004 4.81424 4.67714 4.67714C4.81424 4.54004 5.00011 4.46291 5.194 4.46267H44.686C44.8799 4.46291 45.0658 4.54004 45.2029 4.67714C45.34 4.81424 45.4171 5.00011 45.4173 5.194V32.2533Z" />
                          <path d="M41.7607 13.9701C41.7607 12.379 41.2889 10.8236 40.405 9.50071C39.521 8.17777 38.2646 7.14666 36.7946 6.53778C35.3246 5.9289 33.7071 5.76959 32.1466 6.07999C30.5861 6.3904 29.1527 7.15658 28.0276 8.28165C26.9026 9.40671 26.1364 10.8401 25.826 12.4006C25.5156 13.9612 25.6749 15.5787 26.2838 17.0486C26.8926 18.5186 27.9237 19.775 29.2467 20.659C30.5696 21.5429 32.125 22.0148 33.7161 22.0148H34.4474V14.7014H41.7607V13.9701ZM32.9847 20.5118C31.8147 20.3818 30.7009 19.9401 29.7598 19.2329C28.8187 18.5257 28.0846 17.5788 27.6343 16.4911C27.1839 15.4033 27.0338 14.2147 27.1995 13.0492C27.3653 11.8836 27.8409 10.784 28.5766 9.86493L32.9847 14.273V20.5118ZM34.019 13.2388L29.6109 8.83064C30.5299 8.09487 31.6296 7.61928 32.7952 7.45351C33.9607 7.28773 35.1494 7.43786 36.2371 7.8882C37.3248 8.33855 38.2717 9.07262 38.979 10.0138C39.6862 10.9549 40.1279 12.0687 40.2578 13.2388H34.019Z" />
                          <path d="M35.9101 23.4774H36.7328C38.4536 23.4755 40.1034 22.791 41.3202 21.5742C42.537 20.3574 43.2215 18.7076 43.2234 16.9868V16.1641H35.9101V23.4774ZM37.3727 17.6267H41.7202C41.577 18.7296 41.0728 19.7541 40.2865 20.5405C39.5001 21.3269 38.4756 21.831 37.3727 21.9743V17.6267ZM22.0147 5.92542H8.85074C8.26905 5.92607 7.71138 6.15743 7.30007 6.56874C6.88875 6.98006 6.65739 7.53773 6.65674 8.11942V18.3581C6.65739 18.9398 6.88875 19.4974 7.30007 19.9088C7.71138 20.3201 8.26905 20.5514 8.85074 20.5521H22.0147C22.5964 20.5514 23.1541 20.3201 23.5654 19.9088C23.9767 19.4974 24.2081 18.9398 24.2087 18.3581V8.11942C24.2081 7.53773 23.9767 6.98006 23.5654 6.56874C23.1541 6.15743 22.5964 5.92607 22.0147 5.92542ZM22.7461 18.3581C22.7458 18.552 22.6687 18.7378 22.5316 18.8749C22.3945 19.012 22.2086 19.0892 22.0147 19.0894H8.85074C8.65685 19.0892 8.47097 19.012 8.33387 18.8749C8.19678 18.7378 8.11965 18.552 8.11941 18.3581V10.3134H22.7461V18.3581ZM22.7461 8.85075H8.11941V8.11942C8.11965 7.92553 8.19678 7.73965 8.33387 7.60255C8.47097 7.46545 8.65685 7.38832 8.85074 7.38808H22.0147C22.2086 7.38832 22.3945 7.46545 22.5316 7.60255C22.6687 7.73965 22.7458 7.92553 22.7461 8.11942V8.85075ZM6.65674 22.7461H15.4327V24.2088H6.65674V22.7461ZM6.65674 25.6714H13.2387V27.1341H6.65674V25.6714ZM6.65674 28.5968H13.2387V30.0594H6.65674V28.5968ZM35.9101 25.6714H43.2234V27.1341H35.9101V25.6714ZM35.9101 28.5968H43.2234V30.0594H35.9101V28.5968Z" />
                          <path d="M13.0246 16.3782L11.3477 14.7014L13.0246 13.0245L11.9904 11.9902L9.2793 14.7014L11.9904 17.4125L13.0246 16.3782ZM14.012 16.6252L15.4731 12.9704L16.8305 13.5131L15.3694 17.1679L14.012 16.6252ZM18.8753 17.4125L21.5864 14.7014L18.8753 11.9902L17.841 13.0245L19.518 14.7014L17.841 16.3782L18.8753 17.4125Z" />
                        </svg>
                      </div>
                      <div class="service-card-content">
                        <h3>
                          <a href="#"  onClick={(e) => { e.preventDefault(); setOpen(true); }}>Expert Local Insights</a>
                        </h3>
                        <p>
                          Local consultants with industry specific business
                          experience
                        </p>
                        <a href="#" class="view-details-btn"  onClick={(e) => { e.preventDefault(); setOpen(true); }}>
                          Get A Quote
                          <svg
                            class="arrow"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z" />
                            </g>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".5"
                  >
                    <div class="service-card">
                      <div class="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={50}
                          height={50}
                          {...props}
                        >
                          <path d="M22.417 36.146c-.972 0-1.763-.789-1.763-1.761a1.764 1.764 0 0 1 3.526 0c0 .972-.79 1.761-1.763 1.761Zm0-2.04a.28.28 0 0 0-.279.279c0 .307.558.307.558 0a.279.279 0 0 0-.279-.278Zm6.627 2.04a1.763 1.763 0 1 1 .002-3.525 1.763 1.763 0 0 1-.002 3.525Zm0-2.04a.278.278 0 0 0-.278.279c0 .307.557.307.557 0a.278.278 0 0 0-.279-.278Zm5.55-14.88a1.715 1.715 0 0 0-1.369-.676H16.366l-.438-1.642a1.91 1.91 0 0 0-1.844-1.416h-1.106a.742.742 0 0 0 0 1.483h1.106c.192 0 .36.13.41.316l3.544 13.25a2.226 2.226 0 0 0 2.148 1.65H32.08a.743.743 0 0 0 0-1.485H20.186a.74.74 0 0 1-.715-.547l-.27-1.012h11.168a2.978 2.978 0 0 0 2.873-2.205l1.653-6.22a1.718 1.718 0 0 0-.3-1.497Zm-1.176.903a.24.24 0 0 1 .042.212l-.735 2.766h-2.606l.413-3.073h2.693c.105 0 .165.06.193.095Zm-4.796 2.978h-2.727v-3.073h3.141l-.414 3.073Zm-4.21-3.073v3.073h-2.724l-.417-3.073h3.14Zm-4.638 0 .416 3.073h-2.601l-.823-3.073h3.008Zm.617 4.557.416 3.072H18.81l-.823-3.072h2.405Zm1.498 0h2.523v3.072h-2.108l-.415-3.072Zm4.006 3.072v-3.072h2.527l-.414 3.072h-2.113Zm4.474 0h-.863l.413-3.072h2.412l-.523 1.968a1.49 1.49 0 0 1-1.438 1.104h-.001ZM14.566 7.408a.695.695 0 0 0-.695-.695H6.238a.695.695 0 1 0 0 1.39h7.633a.695.695 0 0 0 .695-.695Zm20.962 0a.742.742 0 1 1-1.484 0 .742.742 0 0 1 1.484 0Zm2.32-.742a.742.742 0 1 0 0 1.484.742.742 0 0 0 0-1.484Zm3.06 0a.742.742 0 1 0 0 1.484.742.742 0 0 0 0-1.484Zm6.548 32.422L45.18 37.17c.002-.045.01-.09.01-.137V8.047A4.055 4.055 0 0 0 41.142 4H6.047A4.055 4.055 0 0 0 2 8.047v28.986a4.055 4.055 0 0 0 4.047 4.047h31.148l.001 2.78c0 .598.336 1.127.878 1.38a1.52 1.52 0 0 0 1.622-.208l1.39-1.156.773 1.663a2.136 2.136 0 0 0 3.947-.167 2.118 2.118 0 0 0-.07-1.634l-.773-1.664 1.779-.318a1.513 1.513 0 0 0 1.204-1.108 1.51 1.51 0 0 0-.49-1.56ZM3.481 8.047a2.566 2.566 0 0 1 2.566-2.56h35.096a2.566 2.566 0 0 1 2.566 2.56v1.279H3.48v-1.28Zm33.712 25.666.002 5.88H6.047a2.566 2.566 0 0 1-2.566-2.559v-26.22h40.227V35.93l-4.01-3.38a1.51 1.51 0 0 0-1.624-.216 1.508 1.508 0 0 0-.88 1.38Zm9.286 6.583-2.725.486a.74.74 0 0 0-.542 1.044l1.179 2.54a.646.646 0 0 1 .022.497.662.662 0 0 1-.586.43.653.653 0 0 1-.623-.379l-1.179-2.536a.743.743 0 0 0-1.147-.258l-2.198 1.74.062-10.178 7.757 6.54-.02.074Z" />
                        </svg>
                      </div>
                      <div class="service-card-content">
                        <h3>
                          <a href="#"  onClick={(e) => { e.preventDefault(); setOpen(true); }}>A Growing Global Network</a>
                        </h3>
                        <p>Growing solution partner ecosystem</p>
                        <a href="#" class="view-details-btn"  onClick={(e) => { e.preventDefault(); setOpen(true); }}>
                          Get A Quote
                          <svg
                            class="arrow"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M6.36416 4.94963C6.37964 5.45628 8.04642 6.14441 8.42737 6.15328L12.6752 6.15328L4.95937 13.8691C4.68614 14.1423 4.68613 14.5853 4.95937 14.8585C5.23261 15.1318 5.67561 15.1318 5.94884 14.8585L13.6646 7.14275L13.6646 11.3905C13.6647 11.7769 14.4631 13.4349 14.8494 13.4349C15.2358 13.4349 15.0638 11.7769 15.0638 11.3905L15.0638 5.45367C15.0637 5.06733 14.7506 4.75416 14.3642 4.75408L8.42738 4.75408C8.0235 4.759 6.35447 4.4862 6.36416 4.94963Z" />
                            </g>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".5"
                  >
                  
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".4"
                  >
                  
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".3"
                  >
                    
                  </div>
                  <div
                    class="col-xl-3 col-lg-4 col-sm-6 fade_anim"
                    data-delay=".2"
                  >
                  
                  </div>
                </div>
              </div>
              <img
                src="assets/image/start-up/service-section-vector1.png"
                alt=""
                class="vector1 light"
              />
              <img
                src="assets/image/start-up/service-section-vector1-dark.png"
                alt=""
                class="vector1 dark"
              />
              <img
                src="assets/image/start-up/service-section-vector2.png"
                alt=""
                class="vector2 light"
              />
              <img
                src="assets/image/start-up/service-section-vector2-dark.png"
                alt=""
                class="vector2 dark"
              />
            </div>

            <div class="home4-process-section style-3 mb-120">
              <div class="container-fluid two">
                <div class="process-section-wrap">
                  <div class="section-title-wrap">
                    <div class="container">
                      <div class="row gy-3 mb-60 justify-content-between">
                        <div class="col-lg-7">
                          <div class="section-title three">
                            <span>Process </span>
                            <h2 class="text-anim">Our Strategic Foundation</h2>
                          </div>
                        </div>
                        <div class="col-lg-5">
                          <div class="right-content">
                            <p>
                             Driving business excellence with purpose and clarity.
                            </p>
                            <a
                              href="contact.html"
                              class="view-more-btn style-2"
                            >
                              <svg
                                class="border"
                                width="88"
                                height="1"
                                viewBox="0 0 88 1"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect width="88" height="1" />
                              </svg>
                              Let’s Work Together
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="process-wrapper">
                    <div class="single-process mt-30">
                      <div
                        class="process-card wow animate fadeInLeft"
                        data-wow-delay="200ms"
                        data-wow-duration="1500ms"
                      >
                        <div class="step-no">
                          <span> 01</span>
                        </div>
                        <h3>Our Mission</h3>
                        <p>
                          To provide Australian businesses with enterprise-grade CRM tools and bespoke software that simplify complex workflows, enhance productivity, and drive sustainable digital growth..{" "}
                        </p>
                        <svg
                          class="vector"
                          width="75"
                          height="75"
                          viewBox="0 0 75 75"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="25" height="25" fill="#B2B7DD" />
                          <rect
                            x="25"
                            y="25"
                            width="25"
                            height="25"
                            fill="#B2B7DD"
                          />
                          <rect y="50" width="25" height="25" fill="#B2B7DD" />
                          <rect
                            x="50"
                            y="50"
                            width="25"
                            height="25"
                            fill="#B2B7DD"
                          />
                        </svg>
                      </div>
                      <svg
                        class="animated-vector"
                        width="181"
                        height="124"
                        viewBox="0 0 181 124"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.2"
                          id="theMotionPath11"
                          d="M0 123H67.5C84.0685 123 97.5 109.569 97.5 93V31C97.5 14.4315 110.931 1 127.5 1H181"
                          stroke="black"
                        />
                        <path
                          d="M0 0 L13 0"
                          stroke="url(#paint0_linear_354_7441)"
                          stroke-linecap="round"
                          stroke-width="2"
                        >
                          <animateMotion
                            dur="4s"
                            begin="0s"
                            repeatCount="indefinite"
                            rotate="auto"
                          >
                            <mpath href="#theMotionPath11"></mpath>
                          </animateMotion>
                        </path>
                        <defs>
                          <linearGradient
                            id="paint0_linear_354_7441"
                            x1="10"
                            y1="0"
                            x2="0"
                            y2="0"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#CB0000" offset="0" />
                            <stop
                              offset="1"
                              stop-color="white"
                              stop-opacity="0"
                            />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                    <div class="single-process two">
                      <div
                        class="process-card wow animate fadeInUp"
                        data-wow-delay="200ms"
                        data-wow-duration="1500ms"
                      >
                        <div class="step-no">
                          <span>2</span>
                        </div>
                        <h3>Our Vision</h3>
                        <p>
                          To become the leading catalyst for digital transformation in the Melbourne business landscape, setting new standards for intuitive design and intelligent software automation.
                        </p>
                        <svg
                          class="vector"
                          width="75"
                          height="75"
                          viewBox="0 0 75 75"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="25" height="25" fill="#D9C9A2" />
                          <rect
                            x="25"
                            y="25"
                            width="25"
                            height="25"
                            fill="#D9C9A2"
                          />
                          <rect y="50" width="25" height="25" fill="#D9C9A2" />
                          <rect
                            x="50"
                            y="50"
                            width="25"
                            height="25"
                            fill="#D9C9A2"
                          />
                        </svg>
                      </div>
                    </div>
                    <div class="single-process three mt-30">
                      <svg
                        class="animated-vector"
                        width="181"
                        height="124"
                        viewBox="0 0 181 124"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.2"
                          id="theMotionPath12"
                          d="M181 123H113.5C96.9315 123 83.5 109.569 83.5 93V31C83.5 14.4315 70.0685 1 53.5 1H0"
                          stroke="black"
                        />
                        <path
                          d="M0 0 L13 0"
                          stroke="url(#paint0_linear_354_7442)"
                          stroke-linecap="round"
                          stroke-width="2"
                        >
                          <animateMotion
                            dur="4s"
                            begin="0s"
                            repeatCount="indefinite"
                            rotate="auto"
                            keyPoints="1;0"
                            keyTimes="0;1"
                          >
                            <mpath href="#theMotionPath12"></mpath>
                          </animateMotion>
                        </path>
                        <defs>
                          <linearGradient
                            id="paint0_linear_354_7442"
                            x1="10"
                            y1="0"
                            x2="0"
                            y2="0"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#CB0000" offset="0" />
                            <stop
                              offset="1"
                              stop-color="white"
                              stop-opacity="0"
                            />
                          </linearGradient>
                        </defs>
                      </svg>
                      <div
                        class="process-card wow animate fadeInRight"
                        data-wow-delay="200ms"
                        data-wow-duration="1500ms"
                      >
                        <div class="step-no">
                          <span>4</span>
                        </div>
                        <h3>Our Values</h3>
                        <p>
                          We believe in transparency, technical excellence, and long-term partnerships. Every line of code we write and every strategy we build is rooted in delivering genuine value to our clients.
                        </p>
                        <svg
                          class="vector"
                          width="75"
                          height="75"
                          viewBox="0 0 75 75"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="25" height="25" fill="#B5D4A2" />
                          <rect
                            x="25"
                            y="25"
                            width="25"
                            height="25"
                            fill="#B5D4A2"
                          />
                          <rect y="50" width="25" height="25" fill="#B5D4A2" />
                          <rect
                            x="50"
                            y="50"
                            width="25"
                            height="25"
                            fill="#B5D4A2"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

      

        


        

          
          </div>
        </div>
      </div>
    </>
  );
}
